<template>
  <div>
    <div class="pic_question clearfloat" id="vm">
      <input
        @change="fileChange($event)"
        type="file"
        ref="upload_file"
        id="ddddddd"
        multiple
        hidden
        :accept="accept"
      />
      <ul class="img-list clearfloat">
        <li v-for="(url, index) in imgcontainer" :key="index">
          <Icon
            class="del"
            type="md-close-circle"
            @click.stop="delImg('one', index)"
          />
          <img title="下载" :src="url" @click="download(index)" />
        </li>
      </ul>
      <div
        class="add-image"
        @click="open"
        v-if="!(one != undefined && imgcontainer.length == 1)"
      >
        <Icon type="ios-add" />
      </div>

      <!-- <button @click="replace('http:test/1234')">获取数据</button> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["imgModel", "one", "keep", "type"],
  data() {
    return {
      //imgModel: [],
      size: 0,
      limit: 6, //限制图片上传的数量
      tempImgs: [],
      isCamera: true,
      mode: true,
      imgModel123: "",
      imgcontainer: [],
      imgmmm: true,
      words: [],
      accept: ".docx,image/docx",
      icon: "static/word.png",
    };
  },
  methods: {
    download(index) {
      var m = this.axios.platConfig.fileUri + this.words[index];
      window.open(m);
    },
    open() {
      this.$refs.upload_file.click();
    },
    async fileChange(el) {
      var files = el.target.files;
      this.words = [];
      for (let i = 0; i < files.length; i++) {
        var m = el.target.files[i];

        //console.log(m.size / 1024 / 1024, "压缩的图片file");

        let params = new window.FormData();
        params.append("file", m);
        params.append("isOrgFileName", true);
        this.utils.loading(this, "加载中");
        this.axios({
          method: "post",
          url: this.axios.oss + "/file/upload",
          data: params,
        }).then((res) => {
          console.log(res);
          this.$Spin.hide(); //关闭加载
          if (res) {
            console.log(res);
            this.imgcontainer.push(this.icon);

            this.words.push(res.data.data.path);

            if (this.one) {
              this.$emit("bbbbb", this.words[0]);
              console.log(this.words[0]);
            } else {
              this.$emit("bbbbb", this.words);
            }
          }
        });
      }
      return;
    },
    delImg(type, index) {
      this.imgcontainer.splice(index, 1);
    },
    reset() {
      if (this.imgcontainer.length > 0) {
        this.imgcontainer.splice(0, 10);
      }
    },
    imgModelToImgcontainer(v) {
      if (this.one) {
        if (this.utils.isEmpty(v)) {
          this.words = [];
          this.imgcontainer = [];
        } else {
          this.words = [v];
          this.imgcontainer = [this.icon];
        }
      } else {
        if (this.utils.isEmpty(v)) {
          this.words = [];
        } else {
          this.words = v;
        }
      }
    },
  },
  model: {
    prop: "imgModel",
    event: "bbbbb",
  },
  watch: {
    imgModel(v) {
      this.imgModelToImgcontainer(v);
    },
    imgcontainer(v) {
      this.imgmmm = false;
      setTimeout(() => {
        this.imgmmm = true;
      }, 200);
    },
  },
  created() {
    var v = this.imgModel;
    this.imgModelToImgcontainer(v);
    if (this.type == "excel") {
      this.accept = ".xlsx,image/xlsx";
      this.icon = "static/excel.png";
    }
  },
};
</script>
<style>
.pic_question {
  padding: 0 0.48rem;
}

.add-image {
  float: left;
  width: 60px;
  height: 60px;
  font-size: 60px;
  color: #868686;
  position: relative;
  border: 1px solid #7a7a7a;
  text-align: center;
  line-height: 2.8rem;
  font-weight: lighter;
}

.img-list {
  flex-wrap: wrap;
  float: left;
}

.img-list > li {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
  display: inline-block;
}
.img-list > li .del {
  position: absolute;
  top: -8px;
  right: -4px;
  color: #2c2c2c;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  opacity: 0.5;
  font-size: 24px;
}
.img-list > li > img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/word.vue